import React from 'react';
import cx from 'classnames';

import {Tabs} from './Tabs';
import Button from './ButtonNew';
import {useScrollPosition} from '../hooks';

const StickyHeader = ({
  navigationTabs, cta, handleClick, href, headerPosition = 200,
}) => {
  const scrollPosition = useScrollPosition();

  return (
    <div
      className={cx(
        'w-full pt-0 bg-white shadow z-50 transform transition duration-100',
        {
          'opacity-0 h-0 fixed -top-16 -translate-y-16 pointer-events-none':
          scrollPosition < headerPosition,
          'opacity-100 fixed top-0 translate-y-0': scrollPosition > headerPosition,
        },
      )}
    >
      <div className="hidden lg:flex max-w-6xl mx-auto px-4 justify-between items-center">
        <Tabs
          tabs={navigationTabs}
          className="border-none"
          onClick={(key) => {
            document.getElementById(key)?.scrollIntoView({behavior: 'smooth'});
          }}
        />
        <Button className="flex-grow-0" onClick={handleClick} href={href}>
          {cta}
        </Button>
      </div>
    </div>
  );
};

export default StickyHeader;
